import React, {useEffect, useState} from 'react';
import {RouteComponentProps, Link} from 'react-router-dom';
import {
  Box,
  Typography,
  Breadcrumbs,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  TablePagination,
  Button,
} from '@material-ui/core';
import {apiGetContracts, apiGetUser} from './utils/graph';
import {IUser} from 'constants/interfaces';
import AddIcon from '@material-ui/icons/Add';
import {ESidePanelView} from 'constants/index';
import {reduxToggleSidePanel} from 'appredux/actions';
import {IContract} from './models';
import {useSelector} from 'react-redux';

type ContractsProps = RouteComponentProps<{customerUserId: string}>;

const Contracts = (props: ContractsProps) => {
  const {customerUserId} = props.match.params;
  const sidePanel = useSelector((state: any) => state.sidepanel);
  const [customerData, setCustomerData] = useState<IUser>();
  //   const [pagedData /* , setPagedData*/] = useState<any>([]);
  const [data, setData] = useState<Array<IContract>>([]);
  const [isLoading /* , setIsLoading*/] = useState(true);
  const [page /* , setPage*/] = useState(0);
  const [rowsPerPage /* , setRowsPerPage*/] = useState(10);
  useEffect(() => {
    apiGetUser(props.match.params.customerUserId)
      .then((user) => {
        setCustomerData(user);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  useEffect(() => {
    if (customerData?.farmer?.id) {
      apiGetContracts(customerData?.farmer?.id as any).then((contracts) => {
        setData(contracts);
      });
    }
  }, [customerData, sidePanel]);
  const openAddContract = () => {
    reduxToggleSidePanel(
      true,
      {
        panelType: ESidePanelView.ADD_CUSTOMER_CONTRACT,
        data: {
          farmId: customerData?.farmer?.farm?.id,
          farmerId: customerData?.farmer?.id,
        },
      },
      false,
    );
  };
  const farmName = customerData?.farmer?.farm?.name || 'Farm Name';
  return (
    <div className="contracts-container customers-container">
      <Box mb={2} className="breadcrumb-row">
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            to="/customers"
            style={{textDecoration: 'none', color: '#267373'}}
          >
            Farmers
          </Link>
          <Link
            to={`/customers/dashboard/${customerUserId}`}
            style={{textDecoration: 'none', color: '#267373'}}
          >
            {farmName}
          </Link>
          <Typography color="textPrimary" style={{fontWeight: 700}}>
            Contracts
          </Typography>
        </Breadcrumbs>
      </Box>
      <Typography variant="h5" className="page-title">
        Contracts
      </Typography>
      <div className="search-row">
        <div></div>

        <div className="actions-right">
          <Button variant="outlined" className="filter-button" disabled>
            Filter
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={openAddContract}
            size="medium"
            className="add-customer-button"
          >
            Create new contract
          </Button>
        </div>
      </div>
      <Box className="table-container">
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Contract Type</TableCell>
                <TableCell>Farmer</TableCell>
                <TableCell>Client</TableCell>
                <TableCell>Crop</TableCell>
                <TableCell>Variety</TableCell>
                <TableCell>Hectares</TableCell>
                <TableCell>Fields</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data?.map((contract: IContract) => {
                const farmName = contract?.farmer?.farm?.name || '';

                return (
                  <TableRow
                    key={contract.id}
                    onClick={() => null}
                    style={{cursor: 'pointer'}}
                  >
                    <TableCell>{contract.createdAt}</TableCell>
                    <TableCell>{contract.contractType?.name}</TableCell>
                    <TableCell>{farmName}</TableCell>
                    <TableCell>{contract?.buyer?.company?.name}</TableCell>
                    <TableCell>{contract?.produce?.name}</TableCell>
                    <TableCell>{contract?.variety?.name}</TableCell>
                    <TableCell>{contract?.hectaresPlanted}</TableCell>
                    <TableCell>{contract?.fields?.length}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                );
              })}

              {/* If no data */}
              {data.length === 0 && !isLoading && (
                <TableRow>
                  <TableCell colSpan={5}>No farmers found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={data.length}
          page={page}
          // onChangePage={handleChangePage}
          onChangePage={() => null}
          rowsPerPage={rowsPerPage}
          // onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Box>
    </div>
  );
};

export default Contracts;
